var AttendeeNotifications = require('./AttendeeNotifications.js').default
var $ = require('jquery')

function initAttendeeNotifications (selector, config, window) {
  
  var AttendeeNotificationsController = AttendeeNotifications(selector, config)
  AttendeeNotificationsController.reloadNotifications()

  $(window).resize(function() {
      positionNotificationsContainer()
  });

  $(document).on('click','#close-notifications-button',function() {
      hideNotificationsContainer()
  });

  $(document).on('click','.nav-notifications-button',function() {
      positionNotificationsContainer()

      window.AttendeeNotificationsController.reloadNotifications()

      if ($("#notifications-container").css('display') == "block") {
          hideNotificationsContainer()
      } else {
          showNotificationsContainer()
      }
  });

  $(document).on('click','html',function(e) {
    if($('#notifications *').is(e.target) || 
    $('.notifications-nav__link').is(e.target) || 
    $('.notifications-nav__text').is(e.target) || 
    $('.notifications-nav__icon').is(e.target) || 
    $('.notifications-nav__count').is(e.target)) { 
        return;
    } else {
        hideNotificationsContainer()  
    }
  });

  var hideNotificationsContainer = function() {
    $("#notifications-container").removeClass('active')
    $("#notifications-container").css('display', 'none');
    $('.navbar-settings__notification-bell').removeClass('active')
  }

  var showNotificationsContainer = function() {
    $("#notifications-container").addClass('active');
    $("#notifications-container").css('display', 'block');
    $("#notifications-container").focus();
    $('#close-notifications-button > i').css('focusable', 'true');
    $('.navbar-settings__notification-bell').addClass('active')
  }

  var positionNotificationsContainer = function() {
      var left = $("#header-content").width();
      var top = 0
      var width = 300
      if ($(".mobile-navbar-external").is(":visible")) {
          left = 0
          top = $(".mobile-navbar-external").css('height');
          width = $("#header-content").css('width');
      }

      if ($("body").hasClass("top-nav-layout")) {                
          if ((!$(".mobile-navbar-external").is(":visible"))) {
              top = $('.navbar').height() + 2
          }

          $("#notifications-container").css('right', 0);
          $("#notifications-container").css('box-shadow', "rgb(64, 64, 64) -5px 4px 5px");
      } else {
          $("#notifications-container").css('left', left);
          $("#notifications-container").css('box-shadow', "rgb(64, 64, 64) 5px 4px 5px");
      }
      $("#notifications-container").css('top', top);
      $("#notifications-container").css('width', width);
      $("#notifications-dropdown-container").css('height', window.innerHeight - top - 50)
  }

  if ($("body").hasClass("top-nav-layout")) {  
      $("#notifications-popup").css('top', "10rem");
  } else {
      $("#notifications-popup").css('top', "1rem");
  }

  window.openNotificationPanel = function () {
      positionNotificationsContainer()
      window.AttendeeNotificationsController.reloadNotifications()
      showNotificationsContainer()
  }  

  return AttendeeNotificationsController
}

export default initAttendeeNotifications